import * as ActionsTypes from "../../../../common/constants/stateConstants";

/*---------------------------------------------CREATION-NOUVEAU-PACKAGE-------------------------------------------------*/
export const creationNouveauPackageAction = (payload) => {
  return {
    type: ActionsTypes.CREATION_NOUVEAU_PACKAGE,
    payload,
  };
};

export const creationNouveauPackageSuccessAction = (payload) => {
  return {
    type: ActionsTypes.CREATION_NOUVEAU_PACKAGE_SUCCESS,
    payload,
  };
};

export const creationNouveauPackageFailAction = (payload) => {
  return {
    type: ActionsTypes.CREATION_NOUVEAU_PACKAGE_FAIL,
    payload,
  };
};

export const creationNouveauPackageReinitializationAction = (payload) => {
  return {
    type: ActionsTypes.CREATION_NOUVEAU_PACKAGE_REINITIALIZATION,
    payload,
  };
};
